import { useQuery } from '@tanstack/react-query';
import { fetchCustomerList } from 'utils/API/Merchant APIs/UpdatedAPIs/DMTUpdatedAPICalls';
import { QUERY_KEYS } from './QueryKeys';

const LIMIT = 10;

export const useCustomers = (page, search, navigate) => {
    return useQuery({
        queryKey: QUERY_KEYS.CUSTOMERS_LIST(page, search),
        queryFn: async () => {
            const response = await fetchCustomerList('fino', page, LIMIT, '2', search);
            if (!response?.data?.success) {
                throw new Error(response?.data?.message || 'Failed to fetch customers');
            }
            return {
                customers: Array.isArray(response.data.data.result) ? response.data.data.result : [],
                totalCount: response.data.data.pagination?.totalCount || 0
            };
        },
        enabled: search.length === 0 || search.length === 10,
        staleTime: 30000,
        onError: (error) => {
            navigate('/unauthorized-section', { state: error.message });
        }
    });
};
